export default class CustomVariation {
  constructor(wrappers) {
    this.wrappers = wrappers;

    this.handle();
  }

  handle = async () => {
    this.wrappers.forEach((wrapper) => {
      const radios = wrapper.querySelectorAll("input");
      this.listenerForRadio(radios);
    });
  };

  listenerForRadio = (radios) => {
    radios.forEach((el) => {
      el.addEventListener("change", () => {
        const $select = jQuery(`select[name=${el.getAttribute("name")}]`);
        $select.val(el.value);
        $select.trigger("change");
      });
    });
  };
}
